<nb-card>
    <nb-card-header>
        <div class="title">{{title}}</div>
        <div class="action">
            <nb-actions size="small">
                <nb-action>
                    <nb-icon icon="close-circle-outline" pack="eva" (click)="close()"></nb-icon>
                </nb-action>
            </nb-actions>
        </div>
    </nb-card-header>
    <div class="wrapper">
        <!-- <ng-container *ngIf="findForm"> -->
            <kve-lookup-form [ofbizForm]="findForm"></kve-lookup-form>
            <!-- <ubs-lookup-dialog-form-container [ofbizForm]="findForm" [title]="title" (setLookupSelectedValue)="getLookupSelectedValue($event)"></ubs-lookup-dialog-form-container> -->
        <!-- </ng-container> -->
        <ng-container *ngIf="listForm">
            <!-- {{listForm?.listFormName}} -->
             <kve-lookup-list [listForm]="listForm"></kve-lookup-list>
            <!-- <ubs-lookup-dialog-list-container [listForm]="listForm" title="title"></ubs-lookup-dialog-list-container> -->
        </ng-container>
    </div>
</nb-card>
